export const HAS_FIRED_LANDING_ITEMS_IMPRESSION = 'HAS_FIRED_LANDING_ITEMS_IMPRESSION';
export function hasFiredLandingItemsImpressions() {
    return {
        type: HAS_FIRED_LANDING_ITEMS_IMPRESSION,
    };
}
export const HAS_FIRED_SELLER_ITEMS_IMPRESSION = 'HAS_FIRED_SELLER_ITEMS_IMPRESSION';
export function hasFiredSellerItemsImpressions() {
    return {
        type: HAS_FIRED_SELLER_ITEMS_IMPRESSION,
    };
}

export const HAS_FIRED_COMPLEMENTARY_ITEMS_IMPRESSION = 'HAS_FIRED_COMPLEMENTARY_ITEMS_IMPRESSION';
export function hasFiredComplementaryItemsImpressions() {
    return {
        type: HAS_FIRED_COMPLEMENTARY_ITEMS_IMPRESSION,
    };
}
